import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Sparkles } from 'lucide-react';

/**
 * Public banner: shown on landing page or any public/client page.
 * Uses raw axios because it's public (no auth header needed).
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function DailyPromoBanner() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/public/promotions/today`).then(r => {
      setData(r.data);
    }).catch(() => setData(null));
  }, []);

  if (!data) return null;
  const { daily, calendar_today, date } = data;

  if (!daily && (!calendar_today || calendar_today.length === 0)) return null;

  return (
    <div className="bg-gradient-to-r from-rose-900 via-rose-700 to-amber-600 text-white py-6 px-4 rounded-2xl shadow-2xl mb-6"
         data-testid="daily-promo-banner">
      <div className="max-w-6xl mx-auto">
        <h2 className="flex items-center gap-2 text-2xl font-bold">
          <Sparkles className="w-6 h-6 text-amber-200" /> Promotions du jour
          <span className="text-sm font-normal opacity-80 ml-auto">{date}</span>
        </h2>

        {daily && (
          <div className="mt-4 flex flex-wrap items-center gap-4 bg-black/20 rounded-xl p-4">
            <div className="flex-1 min-w-[200px]">
              <div className="text-xs uppercase opacity-80">Coup de cœur du jour</div>
              <div className="text-xl font-bold">{daily.product_designation}</div>
              <div className="text-sm opacity-80">Réf {daily.product_ref}</div>
            </div>
            <div className="text-right">
              <div className="text-5xl font-black text-amber-200" data-testid="daily-discount">−{daily.discount_percent}%</div>
              <div className="text-sm">
                <span className="line-through opacity-60">{Number(daily.product_price_original).toFixed(2)} €</span>
                {' → '}
                <span className="text-amber-100 font-bold text-lg">{Number(daily.price_after).toFixed(2)} €</span>
              </div>
            </div>
          </div>
        )}

        {calendar_today && calendar_today.length > 0 && (
          <div className="mt-4">
            <div className="text-xs uppercase opacity-80 mb-2">Aussi en promo aujourd'hui</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
              {calendar_today.map(p => (
                <div key={p.id} className="bg-black/20 rounded p-2 text-sm">
                  <div className="truncate font-semibold">{p.product_designation}</div>
                  <div className="text-amber-200 font-bold">−{p.discount_percent}%</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
